import { actionTypes } from "./storeTypes";

export const init_local = {
  activeLineName: "",
  filter: {
    VectorSet: ["Close", "TopBottom"],
    VecLevel: [],
    VecEvents: [],
    VecDates: [],
  },
  filterDefaults: {
    VectorSet: [],
    VecLevel: [],
    VecEvents: [],
    VecDates: [],
  },
  loading: true,
  modelDateItem: null,
  strengthData: undefined,
  tableViewSelectedKey: "",
  vectorSet2: { rawdata: [], rawdatacombined: [] },
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_ACTIVELINE: {
      return {
        ...state,
        activeLineName: action.payload,
      };
    }
    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case actionTypes.SET_FILTER_DEFAULTS: {
      return {
        ...state,
        filterDefaults: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case actionTypes.SET_MODEL_DATE_ITEM: {
      return {
        ...state,
        modelDateItem: action.payload,
      };
    }
    case actionTypes.SET_STRENGTH_DATA: {
      return {
        ...state,
        strengthData: action.payload,
      };
    }
    case actionTypes.SET_TABLE_VIEW_SELECTED_KEY: {
      return {
        ...state,
        tableViewSelectedKey: action.payload,
      };
    }
    case actionTypes.SET_VECTORSET2: {
      return {
        ...state,
        vectorSet2: action.payload,
      };
    }
    default:
      return state;
  }
}
